import PurchaseOrder from '@/models/PurchaseOrder/PurchaseOrder';

export default class PurchaseOrderFilter {

	constructor() {
		/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.purchaseOrderNumber = '';
		this.purchaseRequestId = '';
		this.purchaseRequestPurchaseRequestNumber = '';
		this.purchaseOrderDateFrom = '';
		this.purchaseOrderDateTo = '';
		this.deliveryDateRequestFrom = '';
		this.deliveryDateRequestTo = '';
		this.purposeMultiple = '';
		this.remarkMultiple = '';
		this.totalQtyFrom = '';
		this.totalQtyTo = '';
		this.totalAmountFrom = '';
		this.totalAmountTo = '';
		this.poStatusId = '';
		this.subcontractRequestDelivery = '';
		this.totalPricePpnFrom = '';
		this.totalPricePpnTo = '';
		this.revisi = '';
		this.vendorId = '';
		this.vendorCode = '';
		this.contactPerson = '';
		this.quotationNumber = '';
		this.quotationDateFrom = '';
		this.quotationDateTo = '';
		this.ppnFrom = '';
		this.ppnTo = '';
		this.partClassificationFromPr = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
		/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
			/*APP_APP_FILTER_CRITERIA*/
			id: '0',
			purchaseOrderNumber: '0',
			purchaseRequestId: '0',
			purchaseRequestPurchaseRequestNumber: '0',
			purchaseOrderDateFrom: '0',
			purchaseOrderDateTo: '0',
			deliveryDateRequestFrom: '0',
			deliveryDateRequestTo: '0',
			purposeMultiple: '0',
			remarkMultiple: '0',
			totalQtyFrom: '0',
			totalQtyTo: '0',
			totalAmountFrom: '0',
			totalAmountTo: '0',
			poStatusId: '0',
			totalPricePpnFrom: '0',
			totalPricePpnTo: '0',
			revisi: '0',
			vendorId: '0',
			vendorCode: '0',
			contactPerson: '0',
			quotationNumber: '0',
			quotationDateFrom: '0',
			quotationDateTo: '0',
			ppnFrom: '0',
			ppnTo: '0',
			partClassificationFromPr: '0',
			isFromUpload: '0',
			isSavedToBackend: '0',
			/*END_APP_FILTER_CRITERIA*/
		};
	}

}